/**
 * Single source of truth for the Firebase web config.
 *
 * Unlike the tenant app there are no fallback values here: admin has no Firebase
 * web app registered yet, so there is no valid appId to fall back to. Until the
 * REACT_APP_FIREBASE_* variables are set, remote config resolves to its
 * in-app defaults.
 */
export const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY || '';
export const FIREBASE_AUTH_DOMAIN = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '';
export const FIREBASE_PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID || '';
export const FIREBASE_STORAGE_BUCKET = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '';
export const FIREBASE_MESSAGING_ID = process.env.REACT_APP_FIREBASE_MESSAGING_ID || '';
export const FIREBASE_APP_ID = process.env.REACT_APP_FIREBASE_APP_ID || '';
export const FIREBASE_MEASUREMENT_ID = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || '';

export const firebaseConfig = {
  apiKey: FIREBASE_API_KEY,
  authDomain: FIREBASE_AUTH_DOMAIN,
  projectId: FIREBASE_PROJECT_ID,
  storageBucket: FIREBASE_STORAGE_BUCKET,
  messagingSenderId: FIREBASE_MESSAGING_ID,
  appId: FIREBASE_APP_ID,
  measurementId: FIREBASE_MEASUREMENT_ID
};

export const isFirebaseConfigured = Boolean(FIREBASE_PROJECT_ID && FIREBASE_APP_ID);
